export function renderAdminDataTemplateGeneratedValueTemplate({
  namespaceCamel,
  projectName
}: {
  namespaceCamel: string
  projectName: string
}): string {
  return `export const ${namespaceCamel} = {
  name: '${projectName}',
}
`
}
